// extracted by mini-css-extract-plugin
export default {"submitButton":"MUHXFVQOBzMzgqWdfw5Y","placeHolderShimmer":"SUBQqUOuahu2o6CahwfJ"};